import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const debug = process.env.NODE_ENV !== 'production';
const plugins = debug ? [createLogger()] : [];

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    groups: [],
    layout: 'loading-layout',
    plays: [],
    capecs: [],
    techniques: [],
    controls: [],
    cwes: [],
    users: [],
    selected: {
      play: {},
      capec: {},
      technique: {},
      control: {},
      cwe: {}
    },
    pagination: {
      plays: {},
      capecs: {},
      techniques: {},
      controls: {},
      cwes: {}
    },
    formFilterOptions: {
      capecs: [],
      controls: [],
      cwes: [],
      families: [],
      groups: [],
      objectives: [],
      platforms: [],
      plays: [],
      tactics: [],
      tags: [],
      techniques: [],
      tools: []
    },
    pendingApproval: {
      count: 0,
      tools: [],
      tags: [],
      objectives: [],
      plays: []
    },
    scenarioBuilder: {
      show: false,
      classification: '',
      name: '',
      description: '',
      plays: [],
      includeAppendix: {
        capec: false,
        mitre: false,
        nist: false,
        cwe: false
      }
    },
    apiLoading: false,
    apiError: { show: false, message: '' },
    authError: { show: false, message: '' },
    crudMessage: {
      show: false,
      color: '',
      text: '',
      type: ''
    }
  },
  actions,
  getters,
  mutations,
  plugins
});
